const isRoleForRemove = (role) => {
    return role === 'OWNER' || role === 'ACCOUNTANT' || role === 'STATE_OWNER' || role === 'STATE_ACCOUNTANT' || role === 'EDITOR';
};

export default isRoleForRemove;
